import axios from 'axios'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_TEST_API,
  // 超时
  timeout: 30000
})

axios.interceptors.request.use(function (config) {
// 在发送请求之前做些什么
  return config
}, error => {
// 对请求错误做些什么
  console.log(error)
  Promise.reject(error)
})
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
// 对响应数据做点什么
  return response
}, error => {
// 对响应错误做点什么
  console.log(error)
  Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/util/request.js